let filePondLib = null

export async function loadFilePond() {
  if (filePondLib) return filePondLib

  const [
    FilePondModule,
    FileEncode,
    ValidateType,
    ImagePreview,
    FilePoster,
    MediaPreview,
    ValidateSize
  ] = await Promise.all([
    import('filepond'),
    import('filepond-plugin-file-encode'),
    import('filepond-plugin-file-validate-type'),
    import('filepond-plugin-image-preview'),
    import('filepond-plugin-file-poster'),
    import('filepond-plugin-media-preview'),
    import('filepond-plugin-file-validate-size')
  ])

  const FilePond = FilePondModule.default || FilePondModule

  FilePond.registerPlugin(
    FileEncode.default || FileEncode,
    ValidateType.default || ValidateType,
    ImagePreview.default || ImagePreview,
    FilePoster.default || FilePoster,
    MediaPreview.default || MediaPreview,
    ValidateSize.default || ValidateSize
  )

  filePondLib = FilePond
  return FilePond
}
